module.exports = __webpack_public_path__ + "img/phone.b6ea6210.webp";